import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '@/views/Main'
import Notification from './modules/Notification' // 通知
import SelectedProject from './modules/SelectedProject' // 入选项目
import TrainingUnit from './modules/TrainingUnit' // 培训单位项目

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "LoginView" */ '../views/LoginView.vue')
  },
  {
    path: '/',
    component: Main,
    children: [
        {
            path: '/',
            redirect: '/index'
        },
        {
          path: '/index',
          name: 'index',
          component: () => import(/* webpackChunkName: "IndexView" */ '../views/IndexView.vue')
        },
        {
          path: '/trainingUnitIndex', // 培训单位首页
          name: 'trainingUnitIndex',
          component: () => import(/* webpackChunkName: "trainingUnitIndex" */ '../views/TrainingUnitIndex.vue')
        },
        {
          path: '/form', // 杰出人才表单
          name: 'form',
          component: () => import(/* webpackChunkName: "FormView" */ '../views/FormView.vue')
        },
        {
          path: '/qnkjTalentForm', // 青年科技人才表单
          name: 'qnkjTalentForm',
          component: () => import(/* webpackChunkName: "qnkjTalentForm" */ '../views/qnkjTalentForm.vue')
        },
        {
          path: '/qnkjAwardForm', // 青年科技奖表单
          name: 'qnkjAwardForm',
          component: () => import(/* webpackChunkName: "qnkjAwardForm" */ '../views/qnkjAwardForm.vue')
        },
        {
          // 我的申报
          path: '/myDeclaration',
          name: 'myDeclaration',
          component: () => import('../views/MyDeclaration.vue')
        },
        {
          path: '/FillingInstructions',
          name: 'FillingInstructions',
          component: () => import('../views/FillingInstructions.vue')
        },
        ...Notification,  // 通知
        ...SelectedProject, // 入选项目
        ...TrainingUnit, // 培训单位
    ]
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.NODE_ENV === 'production' ? '/tjcastssshttglptindex/' : '/',
  routes
})

export default router
